import TablePage from '@/found/components/table_page';

export default {
  name: 'columnMRiskDetailList',
  extends: TablePage,
  props: {
    propsObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      requestType: 'POST',
      params: {},
      isCalculateHeight: false,
    };
  },
  created() {
    this.params = {
      sourceType: this.propsObj.sourceType,
      idCard: this.propsObj.idCard,
      updateTime: this.propsObj.updateTime,
    };
    this.getConfigList('detail_list');
  },
  methods: {
    afterGetList() {
      this.tableData = this.tableData.map((row) => Object.keys(row).reduce((result, key) => ({
        ...result,
        [key]: row[key] === '-' ? '暂无' : row[key],
      }), {}));
      return true;
    },
  },
};
